module.exports = __webpack_public_path__ + "img/desktop-en.15a98b05.png";